import axios from "axios";

// Função de envio de texto
export async function sendMessageToFlowise({ userMsg, chatflowid, apiHost, sessionId, contextVars }) {
  const url = `${apiHost}/api/v1/prediction/${chatflowid}`;
  const payload = {
    question: userMsg,
    overrideConfig: {
      sessionId,
      // CORREÇÃO: Garantindo que a chave seja 'vars'
      vars: contextVars, 
    },
  };
  const response = await axios.post(url, payload);
  // Modificamos para sempre retornar o objeto de dados completo
  return response.data;
}

// Função de envio de áudio (inalterada neste arquivo, a lógica é montada no ChatBody)
export async function sendAudioToFlowise({ payload, chatflowid, apiHost }) {
  const url = `${apiHost}/api/v1/prediction/${chatflowid}`;
  
  const response = await axios.post(url, payload, {
    headers: {
      'Content-Type': 'application/json'
    }
  });

  return response.data;
}

// Função de feedback (inalterada)
export async function sendFeedbackToFlowise({ apiHost, chatflowid, messageId, rating, content, chatId }) {
  const url = `${apiHost}/api/v1/feedback`;
  const payload = {
    chatId,
    chatflowid,
    messageId,
    rating,
    content,
  };
  
  console.log("Enviando payload de feedback:", payload);
  
  await axios.post(url, payload);
}